import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-stack" }, [
  /*#__PURE__*/_createVNode("h3", { class: "m-0 text-white fw-bolder fs-3" }, "Dispositivos activos")
], -1)
const _hoisted_3 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-7" }, "Total", -1)
const _hoisted_5 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_6 = {
  class: "shadow-xs card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1 bg-white",
  style: {"margin-top":"-100px"}
}
const _hoisted_7 = { class: "symbol symbol-60px symbol-2by3 me-4" }
const _hoisted_8 = { class: "d-flex flex-row-fluid flex-wrap align-items-center" }
const _hoisted_9 = { class: "flex-grow-1 me-2" }
const _hoisted_10 = { class: "text-gray-800 fw-bolder fs-6" }
const _hoisted_11 = { class: "text-muted fw-bold d-block pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [`bg-${_ctx.widgetColor}`, "px-9 pt-7 card-rounded h-275px w-100"]
      }, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.total), 1)
        ])
      ], 2),
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: [{ 'mb-7': _ctx.list.length - 1 !== index }, "d-flex align-items-sm-center"]
          }, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", {
                class: "symbol-label",
                style: `background-image: url('${item.image}')`
              }, null, 4)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("a", _hoisted_10, _toDisplayString(item.title), 1),
                _createVNode("span", _hoisted_11, "Cantidad: " + _toDisplayString(item.size), 1)
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ], 2))
}